import type { Asset } from "@/Dashboard/pages/AssetLibrary/types";

export function getFirstSelectedMediaItem(selectedItems: Asset[], selectedItemOrder: string[]): Asset | undefined {
  if (selectedItemOrder.length > 0 && selectedItems.length > 0) {
    const firstSelectedId = selectedItemOrder.find((id) => selectedItems.some((item) => String(item.id) === id));
    if (firstSelectedId) {
      return selectedItems.find((item) => String(item.id) === firstSelectedId);
    }
  }

  // Fallback: if only one item is selected
  if (selectedItems.length === 1) {
    return selectedItems[0];
  }

  return undefined;
}
